import { onUnmounted } from 'vue'

function useDOWCreate(nodeId: string) {
  // 在页面中加入节点实现瞬间移动
  const node = document.createElement('div')
  node.id = nodeId
  document.body.appendChild(node)
  // 组件卸载时 删除节点
  onUnmounted(() => {
    document.body.removeChild(node)
  })
}

export default useDOWCreate
